import Flex from '@Components/Bases/Flex';
import { Alert, Box, Button, Typography } from '@mui/material';
import { formatToThaiDate } from '@Utils/datetime';
import { Dayjs } from 'dayjs';
import { EsgProvidePercentLanguage } from 'src/Enum/EsgPlatform';
import { checkEsgScoreStatus } from './utils';
type EsgPlatformScoreEnProps = {
  esgScore: number | undefined;
  esgUpdateDate: string | Dayjs | undefined;
  hasPercentEn: boolean;
};
const EsgPlatformScoreEn = ({
  esgScore,
  esgUpdateDate,
  hasPercentEn,
}: EsgPlatformScoreEnProps) => {
  const esgStatus = checkEsgScoreStatus(
    esgScore,
    EsgProvidePercentLanguage.EN,
    hasPercentEn
  );
  const message = esgStatus?.message || null;
  const severity = esgStatus?.severity || undefined;

  const handleLinkToEsg = () => {
    const esgDataPlatformUrl: string | undefined =
      process.env.REACT_APP_ESG_DATA_PLATFORM_URL;
    const refreshToken = localStorage.getItem('refreshToken');
    const accessJwt = localStorage.getItem('accessToken');
    const constructedUrl = `${esgDataPlatformUrl}/auth?JWT=${accessJwt}&REFRESH=${refreshToken}`;

    window.open(constructedUrl, '_blank');
  };

  return (
    <Box>
      <Flex
        gap={1}
        flexDirection={'column'}
        sx={{ border: '1px solid rgba(169, 169, 169, 0.3)', borderTop: 'none' }}
        borderRadius={0.5}
      >
        <Box width={'100%'} p={1}>
          {message !== null && (
            <Alert severity={severity}>
              {severity === 'info' ? `คำชี้แจง: ${message}` : message}
            </Alert>
          )}

          <Flex
            mt={3}
            gap={1}
            justifyContent="center"
            alignItems="center"
            flexDirection={'column'}
          >
            <Typography fontWeight={800} variant="h2">
              {esgScore !== null ? `${esgScore} %` : `- %`}
            </Typography>
            <Typography fontWeight={200}>
              {`ข้อมูลล่าสุดเมื่อ ${
                esgUpdateDate && formatToThaiDate(esgUpdateDate)
              }`}
            </Typography>
          </Flex>
        </Box>
        <Box
          p={1}
          borderTop={'1px solid rgba(169, 169, 169, 0.3)'}
          display="flex"
          justifyContent="right"
        >
          <Button onClick={handleLinkToEsg}>เข้าสู่ ESG Data platform</Button>
        </Box>
      </Flex>
    </Box>
  );
};
export default EsgPlatformScoreEn;
